import curry from './curry'
import mergeDeepWithKey from './mergeDeepWithKey'

const mergeDeepRight = curry((obj1, obj2) => {
	return mergeDeepWithKey((key, obj1Val, obj2Val) => {
		return obj2Val
	}, obj1, obj2)
})
export default mergeDeepRight
